import { StandardEvents } from '@shopify/events';

class HundriketDeliveryStock extends HTMLElement {
  #section;
  #request = 0;

  connectedCallback() {
    this.#section = this.closest('.shopify-section, dialog');
    this.#section?.addEventListener(StandardEvents.productSelect, this.#onProductSelect);
  }

  disconnectedCallback() {
    this.#section?.removeEventListener(StandardEvents.productSelect, this.#onProductSelect);
    this.#request += 1;
  }

  #setPending(message, note = '') {
    for (const selector of ['[data-stock-value]', '[data-delivery-value]']) {
      const value = this.querySelector(selector);
      if (value) value.textContent = message;
    }
    for (const selector of ['[data-stock-note]', '[data-delivery-note]']) {
      const value = this.querySelector(selector);
      if (value) value.textContent = note;
    }
    const article = this.querySelector('[data-article-number]');
    if (article) article.textContent = message;
    const stock = this.querySelector('[data-stock-state]');
    if (stock) stock.dataset.stockState = 'unknown';
  }

  #onProductSelect = async (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    const request = ++this.#request;
    this.setAttribute('aria-busy', 'true');
    this.#setPending('Uppdateras…');
    try {
      const { detail } = await event.promise;
      if (request !== this.#request || !this.isConnected) return;
      if (!detail?.html) throw new Error('Missing variant response');
      if (!detail.newProduct && detail.productId && String(detail.productId) !== this.dataset.productId) {
        throw new Error('Product mismatch');
      }
      const next = [...detail.html.querySelectorAll('hundriket-delivery-stock')]
        .find((element) => element.dataset.blockId === this.dataset.blockId);
      const content = next?.querySelector('.hr-delivery-stock__content');
      if (!content) throw new Error('Missing delivery and stock details');
      this.querySelector('.hr-delivery-stock__content')?.replaceWith(content.cloneNode(true));
      this.dataset.productId = next.dataset.productId;
    } catch {
      if (request !== this.#request || !this.isConnected) return;
      this.#setPending('Kan inte uppdateras', 'Ladda om sidan för aktuell information.');
    } finally {
      if (request === this.#request) this.removeAttribute('aria-busy');
    }
  };
}

if (!customElements.get('hundriket-delivery-stock')) {
  customElements.define('hundriket-delivery-stock', HundriketDeliveryStock);
}
